import type { Messages } from "../types";

export const messages: Messages = {
  shared: {
    title: "Konto klienta Fielmann",
    tabs: {
      login: "Logowanie",
      signup: "Rejestracja",
      ariaLabel: "Logowanie i rejestracja",
    },
    languageSwitcher: {
      label: "Wybierz język",
    },
    password: {
      show: "Pokaż hasło",
      hide: "Ukryj hasło",
    },
    header: {
      logoAriaLabel: "Fielmann",
    },
    footer: {
      ariaLabel: "Stopka",
      customerService: "Obsługa klienta",
      legalNotice: "Impressum",
      dataProtection: "Polityka prywatności",
    },
    loading: {
      ariaLabel: "Poczekaj chwilę...",
      content: "Treści są ładowane.",
    },
  },
  login: {
    subtitle: "Zaloguj się za pomocą adresu e-mail i hasła.",
    form: {
      emailLabel: "Adres e-mail *",
      passwordLabel: "Hasło *",
      forgotPassword: "Nie pamiętasz hasła?",
      submitButton: "Zaloguj się",
      credentialError: "E-mail i hasło nie pasują do siebie.",
      genericError: "Wystąpił błąd. Spróbuj ponownie później.",
    },
  },
  signup: {
    subtitle: {
      before: "Skorzystaj z ",
      highlight: "korzyści",
      after: " i utwórz swoje konto klienta Fielmann.",
    },
    benefits: {
      popoverHeading: "Twoje korzyści:",
      closeLabel: "Zamknij",
      items: {
        orders:
          "Wszystkie zamówienia Fielmann wraz z ich statusem w jednym miejscu.",
        visionValues: "Wykorzystaj parametry wzroku przy następnym zamówieniu.",
        appointments: "Umawiaj wizyty i zarządzaj nimi.",
        reorders: "Z łatwością składaj kolejne zamówienia online.",
      },
    },
    form: {
      firstNameLabel: "Imię *",
      lastNameLabel: "Nazwisko *",
      emailLabel: "Adres e-mail *",
      passwordLabel: "Hasło *",
      passwordRepeatLabel: "Potwierdź hasło *",
      submitButton: "Zarejestruj się",
      errorTitle: "Nie udało się utworzyć konta.",
      errorMessage: "Sprawdź wprowadzone dane lub spróbuj ponownie później.",
      genericError: "Wystąpił błąd. Spróbuj ponownie później.",
    },
    consents: {
      requiredError: "Zaakceptuj wymaganą zgodę.",
      unavailableError: "Wystąpił błąd. Spróbuj ponownie później.",
      required: {
        headline: "Zgoda na konto klienta",
        subline:
          "Aby wyświetlać wszystkie treści na twoim koncie klienta (np. zakupy lub wizyty), potrzebujemy twojej zgody.",
      },
      optional: {
        headline: "Czy chcesz otrzymywać spersonalizowane reklamy?",
        subline:
          "Masz wybór: wyrażając zgodę, otrzymujesz dopasowane oferty i informacje. Bez zgody korzystasz z konta klienta bez spersonalizowanych reklam.",
      },
    },
  },
  emailVerification: {
    subtitle: "Nie możesz się zalogować?",
    alertTitle: "Najpierw potwierdź swój adres e-mail.",
    alertBody:
      "Najpierw potwierdź swój adres e-mail, aby aktywować konto Fielmann.",
    alertSpamHint: "Nie możesz znaleźć e-maila? Sprawdź też folder ze spamem.",
    resendButton: "Wyślij e-mail ponownie",
    backToLogin: "Wróć do logowania",
  },
  setPassword: {
    subtitle: "Teraz możesz ustawić hasło.",
    emailLabel: "Adres e-mail *",
    passwordLabel: "Hasło *",
    passwordRepeatLabel: "Potwierdź hasło *",
    submitButton: "Zapisz hasło",
    backToLogin: "Przejdź do logowania",
    successTitle: "Twoje hasło zostało pomyślnie zapisane.",
    successBody: "Teraz możesz się zalogować.",
  },
  toasts: {
    missingRequiredFields:
      "Wypełnij wszystkie jeszcze brakujące pola obowiązkowe, aby kontynuować.",
  },
  validation: {
    passwordRequired: "Podaj hasło.",
    passwordRepeatRequired: "Podaj hasło ponownie.",
    firstNameTooLong: "Imię nie może być dłuższe niż 30 znaków.",
    firstNameRequired: "Podaj imię.",
    firstNameInvalidFormat: "Podaj prawidłowe imię.",
    lastNameTooLong: "Nazwisko nie może być dłuższe niż 30 znaków.",
    lastNameRequired: "Podaj nazwisko.",
    lastNameInvalidFormat: "Podaj prawidłowe nazwisko.",
    emailTooLong: "Adres e-mail jest za długi.",
    emailRequired: "Podaj adres e-mail.",
    emailInvalidFormat: "Podaj prawidłowy adres e-mail.",
    passwordMatchesEmail: "Hasło nie może być identyczne z adresem e-mail.",
    passwordMismatch: "Hasła nie są zgodne.",
  },
  passwordRequirements: {
    minimumLength: "Co najmniej 10 znaków",
    mixedCase: "Co najmniej jedna wielka i jedna mała litera",
    hasNumber: "Co najmniej jedna cyfra",
    specialCharactersAllowed: "Znaki specjalne są dozwolone (np. !@#$%^&*)",
  },
};
